// extracted by mini-css-extract-plugin
module.exports = {"ClaimerLicensorsDiagram":"h_awChHZAmXHyodKbMvS7","ClaimerLicensorsPeriodDiagram":"_17Ingd2HG_d1f7vduYwDjW"};